import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import QueryParamProxy from '../../../utils/queryParamProxy';
import routeParamConstants from '../../../utils/routeParamConstants';
import screens from '../..';
import { cleanTutorialCompleted } from '../../../state/slices/tutorial/tutorial';
var useBattlesUnlocked = function useBattlesUnlocked(props) {
  var navigation = props.navigation,
    dismissModal = props.dismissModal;
  var dispatch = useDispatch();
  var battlesAssets = useSelector(function (state) {
    return state.assetsPackage.assets.BATTLES_FEATURE || {};
  }, shallowEqual);
  var handleBattlesUnlocked = useCallback(function () {
    QueryParamProxy.navigate(navigation, screens.Battles, _defineProperty({}, routeParamConstants.PARAM_BATTLES_TUTORIAL, true));
    dismissModal();
  }, [dismissModal, navigation]);
  useEffect(function () {
    return function () {
      dispatch(cleanTutorialCompleted());
    };
  }, [dispatch]);
  return {
    battlesAssets: battlesAssets,
    dismissModal: dismissModal,
    handleBattlesUnlocked: handleBattlesUnlocked
  };
};
export default useBattlesUnlocked;